



































































































import Vue from "vue";
import graphqlQuery from "@/service/Api";
import { getInitialsName } from "@/helpers";
import InputPrimary from "@/components/input/InputPrimary.vue";
const basePhotoUrl = process.env.VUE_APP_BASE_PHOTO_URL;
export default Vue.extend({
  components: { InputPrimary },
  data() {
    return {
      basePhotoUrl: basePhotoUrl,
      isLoading: false,
      frontDesks: [],
      isPreview: [],
      isEssay: [],
      search: [],
      isPhotoError: [],
    };
  },
  methods: {
    getInitialsName,
    getSafe(f: any) {
      try {
        return f();
      } catch {
        undefined;
      }
    },
    async getFrontdeskDataByUnit() {
      const query = `
        query getFrontdeskDataByUnit(
          $unit: ID!
          $limitEssay: Float!
          $range: DateRange!
        ) {
          getFrontdeskDataByUnit(
            limitEssay: $limitEssay
            unit: $unit
            range: $range
          ) {
            sumQuestionare
            sumAnswer
            averageAnswer
            user {
              fullname
              photo
              unit {
                _id
                name
              }
            }
            essay {
              answer
              date
            }
          }
        }
      `;

      const variables = {
        limitEssay: 99999,
        unit: this.$route.params.upbjj,
        range: {
          from: new Date("2020-01-01"),
          to: new Date(),
        },
      };
      this.isLoading = true;
      await graphqlQuery({ query, variables }).then((res) => {
        this.frontDesks = res.data.getFrontdeskDataByUnit;
        console.log(res.data);
      });
      this.isLoading = false;
    },
  },
  mounted() {
    console.log(basePhotoUrl, process.env.VUE_APP_BASE_PHOTO_URL);
    this.getFrontdeskDataByUnit();
  },
});
